export default __webpack_public_path__ + "static/media/1_0034.92d40d4d.webp";